export default __webpack_public_path__ + "static/media/Commodities.2e57ee31.svg";